import L from "leaflet";

export const Map = {
  mounted() {
    const { name, initialLatitude, initialLongitude } = this.el.dataset;
    L.Icon.Default.imagePath = "/images/leaflet/";
    L.Icon.Default.prototype.options.imagePath = "/images/leaflet/";

    this.$map = this.el.querySelector(".map");
    this.$overlay = this.el.querySelector(".map-overlay");

    this.map = L.map(this.$map, { attributionControl: false }).setView([51.505, -0.09], 2);
    this.markers = L.layerGroup().addTo(this.map);

    this.handleEvent("map:clear-location", () => {
      this.map.invalidateSize();

      // Clear old markers
      this.markers.clearLayers();
    });

    this.handleEvent("map:update-location", (data) => {
      // If the tab/modal just became visible, fix Leaflet sizing
      setTimeout(() => {
        this.map.invalidateSize();

        this.updateToLocation(data);
      }, 50); // small delay helps if there are CSS transitions
    });

    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 5,
    }).addTo(this.map);

    // Set initial location
    this.updateToLocation({
      name,
      latitude: parseFloat(initialLatitude),
      longitude: parseFloat(initialLongitude),
    });
  },

  async updateToLocation({ name, latitude, longitude }) {
    // Default to NYC coordinates
    latitude = latitude || 40.7128;
    longitude = longitude || -74.006;
    this.$overlay.classList.add("hidden");

    // Clear old markers
    this.markers.clearLayers();

    // Add the new marker
    const marker = L.marker([latitude, longitude]).addTo(this.markers);
    marker.bindPopup(name).openPopup();

    // 4. Center map on the current marker
    this.map.setView([latitude, longitude], 1, { animate: true });
  },
};
